import { Link, useNavigate } from "react-router-dom";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import { timeAgo } from "../../utility/CommonFunctions";
import LineLoader from "../Loaders/LineLoader";
import "./NotificationDropdown.css";

export default function NotificationDropdown({
  notifications = [],
  notificationCount = {},
  isLoading = false,
  onFetch = () => {},
  userType = 1,
}) {
  const navigate = useNavigate();

  const getNotificationLink = (item) => {
    const type = item?.data?.type;
    const id = item?.data?.[type + "Id"];
    if (!type) return null;
    if (type === "attendance") return `${RoutesLink?.ar_request_detail}/${id}`;
    if (type === "odRequest") return `${RoutesLink?.od_request_detail}/${id}`;
    if (type === "leave") return `${RoutesLink?.leave_detail}/${id}`;
    if (type === "purchaseRequest") return `${RoutesLink?.purchase_request_detail}/${id}`;
    if (type === "budgetRequest") return userType === 2 ? RoutesLink?.budget_requests : null;
    if (type === "paymentTicket") return `${RoutesLink?.payment_tickets_details}/${id}`;
    return null;
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case "budgetRequest":
        return { icon: "fas fa-chart-pie", color: "#d97706", bg: "#fef3c7" };
      case "leave":
        return { icon: "fas fa-calendar-alt", color: "#2563eb", bg: "#eff6ff" };
      case "attendance":
        return { icon: "fas fa-user-clock", color: "#059669", bg: "#ecfdf5" };
      case "odRequest":
        return { icon: "fas fa-briefcase", color: "#4f46e5", bg: "#eef2ff" };
      case "purchaseRequest":
        return { icon: "fas fa-shopping-cart", color: "#7c3aed", bg: "#f5f3ff" };
      case "paymentTicket":
        return { icon: "fas fa-receipt", color: "#0891b2", bg: "#ecfeff" };
      default:
        return { icon: "fas fa-bell", color: "#2563eb", bg: "#eff6ff" };
    }
  };

  const unseenCount = notificationCount?.unseenNotitfication || 0;

  return (
    <div className="dropdown notif-dropdown-wrapper">
      <button
        className="btn notif-trigger-btn border-0 position-relative d-flex align-items-center justify-content-center dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={onFetch}
        title="Notifications"
      >
        <i className="far fa-bell notif-bell-icon" />
        {unseenCount > 0 && (
          <span className="notif-badge position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
            {unseenCount > 99 ? "99+" : unseenCount}
          </span>
        )}
      </button>

      <div className="dropdown-menu dropdown-menu-end shadow notification-dropdown p-0">
        {/* Modern Header */}
        <div className="notif-header d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-2.5">
            <div className="notif-header-icon-box">
              <i className="far fa-bell" />
            </div>
            <div>
              <h6 className="notif-title m-0">Notifications</h6>
              <span className="notif-subtitle">
                {unseenCount > 0
                  ? `${unseenCount} unread update${unseenCount > 1 ? "s" : ""}`
                  : "Latest updates"}
              </span>
            </div>
          </div>
          {unseenCount > 0 && (
            <span className="notif-unread-pill">
              {unseenCount} New
            </span>
          )}
        </div>

        {/* Loader bar if fetching */}
        {isLoading && <LineLoader />}

        {/* Notification List Body */}
        <div className="notif-body">
          {notifications && notifications.length > 0 ? (
            notifications.slice(0, 10).map((item, i) => {
              const link = getNotificationLink(item);
              const iconMeta = getNotificationIcon(item?.data?.type);
              const itemContent = (
                <div className="notif-item-inner">
                  <div
                    className="notif-type-icon"
                    style={{ background: iconMeta.bg, color: iconMeta.color }}
                  >
                    <i className={iconMeta.icon} />
                  </div>
                  <div className="notif-item-content">
                    <div className="notif-item-row">
                      <span className="notif-item-title" title={item?.data?.title}>
                        {item?.data?.title || "Notification"}
                      </span>
                      <span className="notif-item-time">
                        {timeAgo(item?.createdAt)}
                      </span>
                    </div>
                    <p className="notif-item-desc">
                      {item?.data?.message || item?.message || "No additional details"}
                    </p>
                  </div>
                </div>
              );

              return (
                <div key={i} className="notif-item">
                  {link ? (
                    <Link
                      to={link}
                      state={
                        item?.data?.type === "leave"
                          ? userType === 2
                            ? { type: "request" }
                            : { type: "teamLeaveRequest" }
                          : null
                      }
                      className="notif-item-link"
                    >
                      {itemContent}
                    </Link>
                  ) : (
                    <div className="notif-item-link no-link">
                      {itemContent}
                    </div>
                  )}
                </div>
              );
            })
          ) : (
            !isLoading && (
              <div className="notif-empty-state">
                <div className="notif-empty-icon">
                  <i className="far fa-bell-slash" />
                </div>
                <p className="notif-empty-title">
                  No Notifications
                </p>
                <p className="notif-empty-subtitle">
                  You're all caught up!
                </p>
              </div>
            )
          )}
        </div>

        {/* Modern Footer */}
        <div className="notif-footer">
          <button
            type="button"
            className="notif-view-all-btn"
            onClick={() => navigate(RoutesLink?.notifications)}
          >
            <span>View all notifications</span>
            <i className="fas fa-arrow-right ms-1" />
          </button>
        </div>
      </div>
    </div>
  );
}
